"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$searchContactsById = exports.$searchContacts = exports.$postContact = exports.$patchContact = exports.$getSingleContact = exports.$getPendingContacts = exports.$getNbContacts = exports.$getAcceptedContacts = exports.$deleteContact = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var _constants = require("./constants");
var baseSearch = '/v5/users/search';
var base = '/v5/contacts';
var $deleteContact = _user => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(_user)
});
exports.$deleteContact = $deleteContact;
var $getAcceptedContacts = (limit, page) => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "?&limit=").concat(limit, "&page=").concat(page)
});
exports.$getAcceptedContacts = $getAcceptedContacts;
var $getNbContacts = () => (0, _oldHttpClient.apiClient)({
  method: 'head',
  url: "".concat(base)
});
exports.$getNbContacts = $getNbContacts;
var $getPendingContacts = () => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "?status=").concat(_constants.CONTACT_STATUS.PENDING, "&isInitiator=false")
});
exports.$getPendingContacts = $getPendingContacts;
var $getSingleContact = _user => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_user)
});
exports.$getSingleContact = $getSingleContact;
var $patchContact = (_user, status) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_user),
  body: {
    status
  }
});
exports.$patchContact = $patchContact;
var $postContact = _user => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base),
  body: {
    _user
  }
});
exports.$postContact = $postContact;
var $searchContacts = exports.$searchContacts = function $searchContacts(query) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var sip = arguments.length > 2 ? arguments[2] : undefined;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 200;
  var url = "".concat(baseSearch, "?contactStatus=").concat(_constants.CONTACT_STATUS.ACCEPTED, "&limit=").concat(limit, "&page=").concat(page);
  if (query) url = "".concat(url, "&q=").concat(query);
  if (sip === true || sip === false) url = "".concat(url, "&sip=").concat(sip);
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url
  });
};
var $searchContactsById = _user => {
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url: "/v5/users/".concat(_user, "?mode=full")
  });
};
exports.$searchContactsById = $searchContactsById;